import { useCallback, useEffect } from 'react';

const Scale = () => {
    // const { isLoggedIn: isAuthenticated } = useGlobal();
    const setZoom = useCallback(() => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const ratioWidth = width / 1024;
        const ratioHeight = height / 768;
        const zoomNumber = ratioWidth;

        if (width < 768) {
            if (document.getElementsByClassName('l-auth').length > 0) {
                document.getElementById('root').style.height = '100%';
                document.getElementsByClassName('l-auth')[0].style.zoom = zoomNumber;
                document.getElementsByClassName('l-auth')[0].style.height = '100%';
            }
            if (document.getElementsByClassName('l-main').length > 0) {
                document.getElementById('root').style.height = '100%';
                document.getElementsByClassName('l-main')[0].style.zoom = zoomNumber;
                document.getElementsByClassName('l-main')[0].style.height = '100%';
            }
        } else {
            if (document.getElementsByClassName('l-main').length > 0) {
                document.getElementById('root').style.height = 'unset';
                document.getElementsByClassName('l-main')[0].style.zoom = 1;
                document.getElementsByClassName('l-main')[0].style.height = '100vh';
            }
        }
    }, []);

    useEffect(() => {
        setZoom();
        window.addEventListener('orientationchange', setZoom);
        window.addEventListener('resize', setZoom);
    }, [setZoom]);

    return <></>;
};

export default Scale;
